import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalLetter'
})
export class CapitalLetterPipe implements PipeTransform {

  transform(value: string, mode: 'first' | 'all' = 'first'): string {
    if (!value) return value;
    switch (mode) {
      case 'all':
        return value.replace(/\b\w/g, char => char.toUpperCase()); // "hello world" → "Hello World"
      default:
        return value.charAt(0).toUpperCase() + value.slice(1); // "hello" → "Hello"
    }
  }

}
